import { ClientPortfolioPaymentFrequencyEnum } from "web_myplann/Infrastructure/Api/Api";
import type { LeasingFormInput } from "web_myplann/Portfolio/Forms/LeasingForm/leasingFormSchema";

export const LEASING_FORM_DEFAULT_VALUES: LeasingFormInput = {
	name: "",
	contractNumber: "",
	producer: "",
	product: "",
	productCategoryId: null,
	signedAt: null,
	startAt: null,
	endAt: null,
	fixationEndDate: null,
	originalObligationAmount: null,
	installment: null,
	interestRate: null,
	paymentFrequency: ClientPortfolioPaymentFrequencyEnum.None,
	note: "",
};
